import { Component } from "./Component";
export class MediaListComponent extends Component {
    constructor() {
        super(...arguments);
        this._model = null;
    }
}
